import React, { PropTypes } from 'react';
import _ from 'lodash';
import { renderToString } from 'react-dom/server';

export const SET_CONTENT = 'hg/content/SET_CONTENT';
export const UPDATE_CONTENT = 'hg/content/UPDATE_CONTENT';

export const initialState = {
  content: {},
  isDefaultContent: false,
  initialized: false,
  rawContent: {},
  newContent: {}
};

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_CONTENT:
      return {
        ...state,
        content: action.content,
        rawContent: action.rawContent,
        isDefaultContent: action.isDefaultContent,
        initialized: true
      };
    case UPDATE_CONTENT:
      return {
        ...state,
        content: action.content,
        newContent: action.newContent
      };

    default:
      return state;
  }
};

// default to empty string in prod
export const DEFAULT_VAL = process.env.NODE_ENV === 'production' ? '' : 'DEFAULT_VAL';

const normalizeContent = (rawContent) => {
  return rawContent;
};

class ContentProvider {

  setStore(store) {
    // allow passing a custome store for testing with a mocked store
    this.store = store;
  }

  getStore() {
    return this.store;
  }

  setContent(rawContent, isDefaultContent = false) {
    const state = this.getStore().getState();
    const content = normalizeContent(rawContent, state);

    this.getStore().dispatch({
       type: SET_CONTENT,
       content,
       rawContent,
       isDefaultContent
     });
  }

  updateContent(contentToInject) {
    const state = this.getStore().getState();

    // prevent content update before content is initialized
    if (!state.contentProvider.initialized) {
      return;
    }
    const existingNewContent = state.contentProvider.newContent;
    const newContent = Object.assign({}, existingNewContent, contentToInject);
    const content = Object.assign({}, this.getContent(), contentToInject);

    this.getStore().dispatch({
       type: UPDATE_CONTENT,
       content,
       newContent
     });

  }

  getContent() {
    const state = this.getStore().getState();

    if (!state.contentProvider.initialized) {
      return {};
    }

    return state.contentProvider.content;
  }

  getValue(key, params = [], defaultValue = DEFAULT_VAL) {
    const content = _.get(this.getContent(), key, defaultValue);

    return inject(content, params);
  }

  contentExists(key) {
    return !!_.get(this.getContent(), key);
  }
}

//IMORTANT: 'key' and 'for' are reserved prop names. Using 'contentKey' instead
export const Content = ({contentKey, params, defaultValue}) => {

  return ( /*eslint-disable react/no-danger*/ //disable dangerouslySetInnerHTML warning
    <span className="content" data-content-key={contentKey}>
      <span className="content-value" dangerouslySetInnerHTML={{__html: contentInstance.getValue(contentKey, params, defaultValue)}}/>
      <span className="content-key">{contentKey}</span>
    </span>
  );
};

Content.propTypes = {
  contentKey: PropTypes.string.isRequired,
  params: PropTypes.array,
  defaultValue: PropTypes.string
};

export const inject = (string, params = []) => {
  const result = string.replace(/\$\{p(\d)\}/g, function(match, id) {
    const paramsVal = params[id-1];

    return React.isValidElement(paramsVal) ? renderToString(paramsVal) : paramsVal;
    });

    return result;
};

//Ensure only a singleton is exported
const contentInstance = new ContentProvider();

export default contentInstance;



/** WEBPACK FOOTER **
 ** ./client/shared/packages/contentProvider/src/contentProvider.js
 **/